import Hero from "./components/Hero";
import CategoryShowcase from "./components/CategoryShowcase";
import LatestFeed from "./components/LatestFeed";
import FeaturedPicks from "./components/FeaturedPicks";
import Voices from "./components/Voices";
import SubscribeBand from "./components/SubscribeBand";
import { useJsonLd, usePageMeta } from "@/lib/site";

export default function Home() {
  usePageMeta(
    "明星八卦圈内 - 剧组工作人员、经纪人、业内知情者一手爆料",
    "明星八卦圈内汇集剧组工作人员、经纪人、业内制片与知情者的一手消息。想听剧组真实见闻、经纪人私下吐槽、圈内不为人知的幕后细节，这里每日更新热瓜。"
  );

  useJsonLd({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: "明星八卦圈内",
        url: "https://yslcare.cn/",
        inLanguage: "zh-CN",
        description:
          "汇集剧组工作人员、经纪人、业内制片与知情者一手消息的明星八卦爆料专区。",
      },
      {
        "@type": "CollectionPage",
        name: "最新圈内爆料 - 明星八卦圈内",
        description:
          "每日更新的剧组、经纪人、业内制片与知情者圈内爆料合集。",
        inLanguage: "zh-CN",
        url: "https://yslcare.cn/",
      },
    ],
  });

  return (
    <>
      <Hero />
      <CategoryShowcase />
      <LatestFeed />
      <FeaturedPicks />
      <Voices />
      <SubscribeBand />
    </>
  );
}